import { NEW_OBJECTS_NAMES } from '../interfaces/villages';
import { INewobjectCategoryForListPresenterSchema } from '../../node/repositories/countryside-search/entities/newobject_category/NewobjectCategoryForListPresenterSchema';
import { INewobjectCategorySetForListPresenterSchema } from '../../node/repositories/countryside-search/entities/newobject_category/NewobjectCategorySetForListPresenterSchema';
import { IVillageForListPresenterSchema } from '../../node/repositories/countryside-search/entities/village/VillageForListPresenterSchema';

interface IPriceMaxMin {
  priceMax: number;
  priceMin: number;
}

const DEFAULT_MAX_MIN: IPriceMaxMin = { priceMax: -Infinity, priceMin: +Infinity };

function reduceMaxMin(acc: IPriceMaxMin, item: IPriceMaxMin | INewobjectCategoryForListPresenterSchema) {
  const [priceMax, priceMin] = [Number(item.priceMax), Number(item.priceMin)];

  return {
    priceMax: priceMax > acc.priceMax ? priceMax : acc.priceMax,
    priceMin: priceMin < acc.priceMin ? priceMin : acc.priceMin,
  };
}

export function getMaxMinPrice(villageList: IVillageForListPresenterSchema[]) {
  return villageList.map(getObjectsMaxMinPrice).reduce(reduceMaxMin, DEFAULT_MAX_MIN);
}

export function getObjectsMaxMinPrice(village: Pick<IVillageForListPresenterSchema, 'newobjectCategorySet'>) {
  return Object.keys(NEW_OBJECTS_NAMES).reduce((acc, key) => {
    const item =
      village.newobjectCategorySet &&
      village.newobjectCategorySet[key as keyof INewobjectCategorySetForListPresenterSchema];
    if (!item) {
      return acc;
    }

    return reduceMaxMin(acc, item);
  }, DEFAULT_MAX_MIN);
}
